import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'statistics',
  initialState: {
    statistics: [],
    isLoading: false,
  },
  reducers: {
    SET_STATISTICS: (state, { payload }) => {
      state.statistics = payload
    },
    IS_LOADING_STATISTICS: (state, { payload }) => {
      state.isLoading = payload
    },
  },
})

export const { SET_STATISTICS, IS_LOADING_STATISTICS } = slice.actions
export default slice.reducer
